(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-carousel"] && !Shopify.designMode) return;
  try {
    
    class FeaturedCarousel extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (document.readyState === 'complete') {
          this.init();
        } else {
          window.addEventListener('load', () => this.init());
        }
      };
      checkViewport(){
        var $bptablet = 600;
        var $ww = window.innerWidth;
        if($ww < $bptablet) {
            this.swiper.slideTo(1)
        }

      }

      init() {
        this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
          // Optional parameters
          direction: 'horizontal',
          loop: false,
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: false,
           freeMode: true,
          navigation: {
            nextEl: this.querySelector('[data-swiper-button-next]'),
            prevEl: this.querySelector('[data-swiper-button-prev]'),
          },
          speed: 2000,
          breakpoints: {
            600: {
              slidesPerGroup: 3,
              slidesPerView: 3,
              spaceBetween: 24,
               freeMode: false
            }

          }
        });
        this.checkViewport()
        let scope = this;
        window.addEventListener('resize', function() {
              scope.checkViewport()
        }, true);

      }
    }

    customElements.define('featured-carousel', FeaturedCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    window.addEventListener('load', () => {
      const copyButtons = [...document.querySelectorAll('[data-copy]')];
      copyButtons.forEach(button => {
        button.addEventListener('click', () => {
          navigator.clipboard.writeText(button.textContent)
            .then(() => {
              button.textContent = 'Copied!';
              setTimeout(() => {
                button.textContent = button.dataset.copy;
              }, 1000);
            })
        })
      });
    })
  }) ();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider-alternate"] && !Shopify.designMode) return;
  try {
    
    class HeroCarouselAlternate extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (document.readyState === 'complete') {
          this.init();
        } else {
          window.addEventListener('load', () => this.init());
        }
      };

      init() {
        this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
          direction: 'horizontal',
          loop: true,
          slidesPerView: 1,
          speed: 2000,
          navigation: {
           nextEl: '[data-swiper-button-next]',
           prevEl: '[data-swiper-button-prev]',
         },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable : true
          }

        });
      }
    }

    customElements.define('hero-alt', HeroCarouselAlternate);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
    class Slider extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            window.addEventListener('load', () => {
                this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
                    // Optional parameters
                    autoplay: {
                        delay: Number(this.dataset.speed),
                        disableOnInteraction: false,
                    },
                    direction: 'horizontal',
                    loop: false,
                    navigation: {
                        nextEl: '[data-swiper-button-next]',
                        prevEl: '[data-swiper-button-prev]',
                    },
                    slidesPerView: "auto",
                    speed: Number(this.dataset.speed)
                });
            })
        }
    }
    customElements.define('testimonial-slider', Slider);

  } catch(e) { console.error(e); }
})();
})();
